import { IProdutoRow } from 'pages/registra-venda/registra-venda.model';
import { ItemGerarSkuTrocaSerial, LinhaCupomTroca } from './cupom-troca.model';

export const explodirItensParaCupomTroca = (itens: Array<IProdutoRow>): Array<LinhaCupomTroca> => {
    return itens
        .filter(item => !item.brinde && !item.isTroca)
        .flatMap(item =>
            Array.from({ length: item.quantidade }, (_, index) => ({
                id: `${item.uuid}-${index}`,
                produtoUuid: item.produto.uuid,
                pedidoVendaItemUuid: item.uuid,
                codigoSku: item.produto.codigoSku,
                descricao: item.produto.descritivo,
                precoPraticado: item.quantidade > 0 ? item.valorTotal / item.quantidade : 0,
                selecionado: true,
            })),
        );
};

export const agruparSelecionadosPorPedidoVendaItem = (linhas: Array<LinhaCupomTroca>): Array<ItemGerarSkuTrocaSerial> => {
    const quantidadePorPedidoVendaItem = new Map<string, number>();
    linhas
        .filter(linha => linha.selecionado)
        .forEach(linha => {
            quantidadePorPedidoVendaItem.set(
                linha.pedidoVendaItemUuid,
                (quantidadePorPedidoVendaItem.get(linha.pedidoVendaItemUuid) ?? 0) + 1,
            );
        });
    return Array.from(quantidadePorPedidoVendaItem.entries()).map(([pedidoVendaItemUuid, quantidadeSelecionada]) => ({
        pedidoVendaItemUuid,
        quantidadeSelecionada,
    }));
};
